'use strict';
/**
 * A directive to display the summary of something shared to the community
 */

angular.module('youth').directive('msActivityHelpDrawer', ['$document', function ($document) {
  return {
    templateUrl: 'youth/templates/activity-help-drawer.html',
    replace: true,
    restrict: 'A',
    scope: false,
    link: function link(scope) {
      $document.bind('keypress', function (e) {
        if (scope.helpDrawerVisible && e.keyCode === 27) {
          scope.helpDrawerVisible = false;
          scope.$apply();
        }
      });
    }
  };
}]);